import lazyGettext from 'js-utils/lazy-gettext';

/* GDPR Modal */
export const GDPR_MODAL_HEADER = lazyGettext('Get alerts for new events');
export const GDPR_MODAL_DESCRIPTION = lazyGettext(
    'By clicking okay, you are agreeing to receive marketing emails and notifications about creators you follow so that you don’t miss out.',
);
export const GDPR_ACCEPT_COPY = lazyGettext('Okay');
export const GDPR_REJECT_COPY = lazyGettext('No Thanks');
export const SAVE_ORGANIZER_FOLLOW_PREFERENCE_ERROR = lazyGettext(
    'There was an issue saving your preference.',
);
export const GDPR_COLLECTION_MODAL_HEADER = lazyGettext(
    'Get updates on this collection',
);
export const GDPR_COLLECTION_MODAL_DESCRIPTION = lazyGettext(
    'By clicking okay, you are agreeing to receive marketing emails and notifications about collections you follow so that you don’t miss out.',
);
